import { CAMPAIGN_TARGETS } from 'lib/globals';
import ShopContext from 'context/ShopContext';
import React,{ useContext } from 'react';
import { Alert, Button, ButtonSelect, FormControl, ShopifyResourcePicker } from 'components';

export default function CampaignTarget({ context }) {
    const { state: campaign, validationErrors, validate,setItem } = context;
    const shopContext = useContext(ShopContext);
    return (
        <>
            {campaign.settings.type &&
                <FormControl
                    label="choose products you want to trigger this campaign"
                    error={validationErrors['target.type']}
                    info={
                        campaign.settings.type === 'bundles'
                            ? 'This campaign will show up on the products you choose below. you can show it on specific products or collections'
                            : 'This campaign will show up on the products you choose below. you can show it on all products or specific'
                    }
                >
                    <ButtonSelect
                        options={CAMPAIGN_TARGETS.filter(
                            target => {
                                const isAllProductsBundles = target.value === 'all_products' && campaign.settings.type === 'bundles'
                                return !isAllProductsBundles
                            }
                        )}
                        shopContext={shopContext}
                        BindToContext={[
                            context,
                            'target.type',
                            newValue =>
                                {
                                if(['specific_products','specific_collections'].includes(newValue)){
                                    setItem('target.selected', [])
                                }
                            }
                        ]}
                    />
                </FormControl>}

            {campaign.target.type === 'specific_products' &&
                <FormControl
                    label="Specify the products"
                    error={validationErrors['target.selected']}
                >
                    <ShopifyResourcePicker
                        allowMultiple={20}
                        BindToContext={[context, 'target.selected']}
                    >
                        {trigger =>
                            <Button
                                text="Select Products"
                                type={
                                    validationErrors['target.selected'] &&
                                    !!validationErrors['target.selected'][0]
                                        ? 'danger'
                                        : 'primary'
                                }
                                onClick={trigger}
                                style={{ width: '100%' }}
                            />}
                    </ShopifyResourcePicker>
                </FormControl>}
            {campaign.target.type === 'specific_collections' &&
                <FormControl
                    label="Specify the collections"
                    error={validationErrors['target.selected']}
                >
                    <ShopifyResourcePicker
                        allowMultiple={2}
                        BindToContext={[context, 'target.selected']}
                        type="Collection"
                    >
                        {trigger =>
                            <Button
                                text="Select Collections"
                                type={
                                    validationErrors['target.selected'] &&
                                    !!validationErrors['target.selected'][0]
                                        ? 'danger'
                                        : 'primary'
                                }
                                onClick={trigger}
                                style={{ width: '100%' }}
                            />}
                    </ShopifyResourcePicker>
                </FormControl>}
            {campaign.settings.type === 'add_to_unlock' &&
                (campaign.target.type === 'specific_products' ||
                    campaign.target.type === 'specific_collections') &&
                <Alert
                    {...{
                        type: 'warning',
                        borderPosition: 'border-l-4',
                        iconSize: '2x', // title: "Add To Unlock - Limitation",
                        icon: 'exclamation-circle',
                        customStyle: { icon: 'text-orange-400 self-start mt-1' }
                    }}
                    className="my-6 z-5"
                >
                    <p>
                        Once activated this offer is SITEWIDE. All products in cart will contribute
                        to the unlock goal.
                    </p>
                </Alert>}
        </>
    );
}
